import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6 mb-3" }
const _hoisted_3 = { class: "box mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Dati pagamento", -1)
const _hoisted_5 = { class: "col-sm-6 mb-3" }
const _hoisted_6 = { class: "box mb-3" }
const _hoisted_7 = { class: "boxTitle" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Obiettivo mensile", -1)
const _hoisted_10 = { class: "col-sm-6 mb-3" }
const _hoisted_11 = { class: "box mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, "Commerciale di riferimento", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_payment_data = _resolveComponent("user-payment-data")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_qualifica_provvigioni_selector = _resolveComponent("qualifica-provvigioni-selector")!
  const _component_network_user_selector = _resolveComponent("network-user-selector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_user_payment_data, {
              value: _ctx.user.paymentData
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, "Guadagni & provvigioni (" + _toDisplayString(_ctx.user.pianoProvvigioni.qualifica && _ctx.user.pianoProvvigioni.qualifica.codiceQualifica) + ")", 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.obiettivoMensile) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.user.obiettivoMensile,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createVNode(_component_qualifica_provvigioni_selector, {
              modelValue: _ctx.user,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_accordion, null, {
          title: _withCtx(() => [
            _hoisted_12
          ]),
          default: _withCtx(() => [
            (_ctx.user.commercialeDiRiferimento)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.commercialeDiRiferimento = null))
                  }, "Svuota")
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_network_user_selector, {
              label: "Seleziona",
              modelValue: _ctx.user.commercialeDiRiferimento,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.commercialeDiRiferimento) = $event)),
              userIdentifier: _ctx.user.identifier
            }, null, 8, ["modelValue", "userIdentifier"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}